<div class="container">
  <qai-accordian-panel>
    <span *ngIf="!isEditingName" accordianTitle class="section-title-text">{{ sectionTitle }}</span>
    <input
      *ngIf="isEditingName"
      #nameInput
      accordianTitle
      qai-input
      class="section-name-input"
      [formControl]="sectionNameControl"
      (blur)="stopEditingName()"
      (keydown.enter)="stopEditingName()"
    />

    <div accordianControls class="accordian-controls">
      <button class="icon-btn" (click)="startEditing()" [disabled]="readOnly">
        <qai-icon kind="pencil-edit" [color]="'#616161'" [size]="'16px'" />
      </button>

      <button class="icon-btn" (click)="deleteTheme()" [disabled]="readOnly">
        <qai-icon kind="trash" [color]="'#616161'" [size]="'16px'" />
      </button>
    </div>

    <div accordianContent class="accordian-content-container">
      <qai-dragable
        [listId]="'facts-' + sectionUuid"
        [connectedTo]="otherThemeListIds"
        [items]="factsItems"
        [useDragHandle]="true"
        [dragHandleDisable]="readOnly"
        (itemsChange)="onFactsReordered($event)"
      >
        <ng-template #cardTemplate let-item>
          <div style="display: flex; align-items: center; gap: 8px;">
            <messaging-theme-message
              style="flex: 1;"
              [currentFact]="asFormGroup(item)"
              [sectionUuid]="sectionUuid!"
              [factIndex]="factIndexOf(item)"
              (deleteFactRequested)="deleteFact($event.index, $event.factUuid)"
            ></messaging-theme-message>
          </div>
        </ng-template>
      </qai-dragable>
    </div>

    <div accordianBottomControls class="new-message-button-position">
      <button
        qai-button
        [shape]="'normal'"
        [kind]="'tertiary-text'"
        [size]="'medium'"
        (click)="addNewMessage()"
        [disabled]="readOnly"
      >
        <qai-icon kind="plus" size="'20px'" positionStart />
        <span>Add message</span>
      </button>
    </div>
  </qai-accordian-panel>
</div>
